import { computed } from 'vue';

import { useSelectCalculator } from '../composables/useSelectCalculator';
import { useCalculatorsStore } from '../store/calculators';

export function useCurrentCalculator() {
  const calculatorsStore = useCalculatorsStore();

  const { currentCalculatorId } = useSelectCalculator();

  const currentCalculator = computed(() => {
    if (!currentCalculatorId.value || !calculatorsStore.data) {
      return null;
    }

    return (
      calculatorsStore.data?.find((calculator) => calculator.id === currentCalculatorId.value) ||
      null
    );
  });

  return {
    currentCalculator,
  };
}
